export function composeAddress(addr: {
  state?: string;
  street?: string;
  street2?: string;
  city?: string;
  country?: string;
  zip?: string;
}) {
  const street =
    `${addr.street?.trim() ?? ""} ${addr.street2?.trim() ?? ""}`.trim();
  const city = (addr.city?.trim() ?? "").trim();
  const state = `${addr.state?.trim() ?? ""} ${addr.zip?.trim() ?? ""}`.trim();
  const country = (addr.country?.trim() ?? "").trim();

  return [street, city, state, country].filter((v) => v).join(", ");
}

export function composePhone(phone: { type?: string; number?: string }) {
  return `${phone.type?.trim() ?? ""} ${phone.number?.trim() ?? ""}`.trim();
}
